<template>
  <div class="border-wrapper">
    <!-- <div class="title-img"><img src="../../assets/img/titleioc.png"/></div> -->
    <div class="border-msg">{{message}}</div>
  </div>
</template>

<script>
export default {
  name: 'BorderBox',
  props: ['message']
}
</script>

<style lang="stylus" scoped>
  .title-img
    margin 1px 4px
  .title-img img
    width 18px
    height 18px
  .border-wrapper
    // flex 1 1 auto
    display flex
    align-items center
    .border-margin
      margin 0 3px
      width 2px
      height 20px
    .border-first
      background-color #173a8b
    .border-second
      background-color #1a5aae
    .border-third
      background-color #2299dc
    .border-fourth-left
      width 6px
      border-style solid
      border-color #29cbff
      border-width 3px 0 3px 3px
    .border-fourth-right
      width 6px
      border-style solid
      border-color #29cbff
      border-width 3px 3px 3px 0
    .border-msg
      margin 0 2px
      color #02b5e8
      border-left 5px solid #02b5e8
      padding-left 5px
      font-size 12px
      // font-weight bold
</style>
